import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const e = "webhooks";
class c extends o {
  /**
   * Creates a new webhook.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/webhooks`
   *
   * @param {WebhooksCreateBody} webhookCreateBody - The body of the request containing details for creating webhooks.
   * @returns {Promise<WebhooksCreateResponse>} A promise that resolves to the newly created webhooks.
   */
  createWebhooks = async (t) => {
    const { data: a } = await this.post(
      `${e}`,
      t
    );
    return a;
  };
  /**
   * Tries out a webhook (i.e., simulates an event trigger).
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/webhooks/tryout`
   *
   * @param {WebhookTryoutBody} webhookTryoutBody - The body of the request containing details to tryout a webhook.
   * @returns {Promise<WebhookTryoutResponse>} A promise that resolves to an object containing the payload sent of the webhook tryout.
   * The content of the payload depends on the sent event type.
   */
  tryoutWebhook = async (t) => {
    const { data: a } = await this.post(
      `${e}/tryout`,
      t
    );
    return a;
  };
  /**
   * Updates an existing webhook.
   *
   * HTTP Verb: `PATCH`
   * Endpoint URL: `/webhooks/{id}`
   *
   * @param {WebhookIdParam} id - The ID of the webhook to update.
   * @param {WebhookUpdateBody} webhookUpdateBody - The body of the request containing the updated webhook data.
   * @returns {Promise<Webhook>} A promise that resolves to the updated webhook.
   */
  updateWebhook = async (t, a) => {
    const { data: s } = await this.patch(`${e}/${t}`, a);
    return s;
  };
  /**
   * Deletes a webhook.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/webhooks/{id}`
   *
   * @param {WebhookIdParam} id - The ID of the webhook to delete.
   * @returns {Promise<EmptyResponse>} A promise that resolves to an empty response indicating the webhook was deleted.
   */
  deleteWebhook = async (t) => {
    const { data: a } = await this.delete(`${e}/${t}`);
    return a;
  };
  /**
   * Retrieves all available webhook events.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/webhooks/events`
   *
   * @returns {Promise<WebhookEvent[]>} A promise that resolves to an array of webhook events.
   */
  getWebhookEvents = async () => {
    const { data: t } = await this.get(`${e}/events`);
    return t;
  };
  /**
   * Retrieves a list of webhooks.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/webhooks`
   *
   * @param {WebhookListParams} [webhookListParams] - Optional query parameters to filter the webhooks.
   * @returns {Promise<WebhookListResponse>} A promise that resolves to the list of webhooks.
   */
  getWebhooks = async (t) => {
    const { data: a } = await this.get(`${e}`, t);
    return a;
  };
}
export {
  e as RESOURCE_URI,
  c as Webhooks
};
